export default {
  SET_ROLES: (state, payload) => { 
    let roles = payload || [];
    roles.unshift({ id: null, description : "N/A" });
    state.roles = roles;
  }
}